import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import {
  LogoIcon,
  // NewUpdatesCloudComponent,
  RaychatLogoDarkFa,
  RobotIconComponent,
} from 'assets/icons';
import { MENU_ITEMS } from 'constants/sidebar';
import { RaychatLogo, RaychatLogoEn, ArrowBackCompIcon } from 'assets/icons';
// import { SettingsBoldIcon } from 'assets/icons';
import closeIcon from 'assets/icons/close-outline.svg';
import MenuItem from './MenuItem';
import routes from '../../routes';
import styles from './styles.module.scss';
import useTranslation from 'hooks/useTranslation';
// import { WebsiteSelect } from 'components';
import SelectWorkspace from 'components/Workspace/SelectWorkspace';
import { useDispatch, useSelector } from 'react-redux';
import {
  setSecondMenuCollapsed,
  setSideMenuCollapse,
} from 'redux/layout/layout.actions';
import PackageExpireAlert from './PackageExpireAlert';
import { ResponsiveRobotIllu } from 'assets/illustrations';
import AiBotImage from 'assets/illustrations/ai_banner_human.png';

const getIsSideMenuCollapsed = ({ layoutData }) =>
  layoutData.isSideMenuCollapsed;
const getSelectedWorkspace = ({ websitesData }) =>
  websitesData.selectedWorkspace;
const getPackagesTypes = ({ paymentsData }) => paymentsData.packageTypes;
const getAccountType = ({ userData }) => userData.profile.accountType;
const getRemainingDaysNum = ({ userData }) => userData.profile.remainingDaysNum;

function SideMenu({ showMenu, setShowMenu }) {
  const isSideMenuCollapsed = useSelector(getIsSideMenuCollapsed);
  const packageTypes = useSelector(getPackagesTypes);
  const accountType = useSelector(getAccountType);
  const remainingDaysNum = useSelector(getRemainingDaysNum);

  // show if package is expired or remaining days are less than 7 days
  const showExpireAlertBox =
    accountType === 9 || (remainingDaysNum && remainingDaysNum <= 7);

  const dispatch = useDispatch();
  const selectedWorkspace = useSelector(getSelectedWorkspace);
  const isMdDown = useMediaQuery({
    query: '(max-width: 992px)',
  });
  const [menuHeaderHeight, setMenuHeaderHeight] = useState(0);
  const { getAppLocale, getTranslation } = useTranslation([
    'INSTALLATION',
    'AFFILIATE',
    'COMMON',
    'SETTINGS_PAGE_MUTUAL',
  ]);
  const { t } = getTranslation();
  const isLocaleFa = getAppLocale() === 'fa';
  const appTheme = document.querySelector('body').getAttribute('theme');
  const sideMenuLogo = isSideMenuCollapsed
    ? LogoIcon
    : isLocaleFa
    ? appTheme === 'dark'
      ? RaychatLogoDarkFa
      : RaychatLogo
    : RaychatLogoEn;

  const renderContent = (
    <>
      <div className={styles.main_items} data-collapse={isSideMenuCollapsed}>
        {MENU_ITEMS.map((item) => {
          return (
            <MenuItem
              // subscript={isLocaleFa ? item.subscript_fa : item.subscript_en}
              iconUrl={item.icon}
              text={isLocaleFa ? item.text_fa : item.text_en}
              key={`${item.text_fa}-${item.text_en}`}
              url={item.url}
              expandable={item.expandable}
              subItem={item.subItems}
              hasNotifBadge={!!item.hasNotifBadge}
              notifBadgeTooltipText={
                isLocaleFa
                  ? item.notifBadgeTooltipText_fa
                  : item.notifBadgeTooltipText_en
              }
              isExternalLink={item.isExternalLink}
              {...{ setShowMenu }}
            />
          );
        })}

        <div className={styles.responsive_robot_box}>
          <Link
            to={`/settings/responsive-robot`}
            className={styles.responsive_robot_box_inner}
            data-collapse={isSideMenuCollapsed}
          >
            <img src={ResponsiveRobotIllu} alt='' />

            <span>ربات پاسخگو</span>
          </Link>
        </div>

        {/* ai bot link */}
        <div className={styles.ai_bot_box} data-collapse={isSideMenuCollapsed}>
          <Link to='/settings/ai-bot' className='flex flex-column'>
            <img src={AiBotImage} alt='ai bot' />
            <div className={styles.ai_bot_box__textBox}>
              <span>چت بات هوش مصنوعی</span>
              <ArrowBackCompIcon />
            </div>
          </Link>
        </div>

        {/* <div className={styles.new_updates_box}>
          <a
            href='https://raychat.io/updates'
            target='_blank'
            rel='noreferrer'
            className={styles.new_updates_box_inner}
            data-collapse={isSideMenuCollapsed}
          >
            <NewUpdatesCloudComponent />

            <span>{t('NEW_UPDATES_BRO')}</span>
          </a>
        </div> */}

        {/* <div className={styles.affiliateBox}>
          <div className={styles.gift_box_wrapper}>
            <img src={GiftBox} alt='' />
          </div>

          <div className={styles.selling_content}>
            <p className={styles.selling_system_text}>
              {t('AFFILIATE_WITH_RAYCHAT')}
            </p>

            <Link className={`btn ${styles.more_btn}`} to='/affiliation'>
              {t('KNOW_MORE')}
            </Link>
          </div>
        </div> */}
      </div>

      {/* <div className={styles.settings_item}>
        <MenuItem
          iconUrl={SettingsBoldIcon}
          text={'تنظیمات رایچت'}
          url={routes.profile}
          subItem={[]}
          {...{ setShowMenu }}
        />
      </div> */}
    </>
  );

  const packageName = packageTypes?.[accountType]?.['fa'];

  useEffect(() => {
    if (isMdDown) setShowMenu(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMdDown]);

  useEffect(() => {
    const menuHeaderEl = document.querySelector('#menu_header');
    const menuHeaderHeight = menuHeaderEl?.offsetHeight;

    setMenuHeaderHeight(menuHeaderHeight);
  }, []);

  return (
    <div data-open={showMenu} className={styles.backdrop}>
      <div
        data-selected={false}
        data-open={showMenu}
        className={styles.menu_container}
      >
        <div
          className={styles.menu_collapser}
          data-collapse={isSideMenuCollapsed}
          onClick={() => {
            dispatch(setSideMenuCollapse(!isSideMenuCollapsed));
            if (!!isSideMenuCollapsed) {
              dispatch(setSecondMenuCollapsed(true));
            }
          }}
        >
          {'<'}
        </div>

        <div
          className={styles.heading}
          id='menu_header'
          data-collapse={isSideMenuCollapsed}
        >
          <div
            className={styles.heading_inner}
            data-collapse={isSideMenuCollapsed}
          >
            <Link
              onClick={
                isMdDown &&
                (() => {
                  setShowMenu(false);
                })
              }
              to={routes.websites}
            >
              <div
                className={styles.logo_container}
                data-collapse={isSideMenuCollapsed}
              >
                <img src={sideMenuLogo} alt='logo' draggable='false' />
              </div>
            </Link>

            <div>
              {/* <div className={styles.version_box}>V5.2.4</div> */}
              {isMdDown && (
                <div
                  onClick={() => {
                    setShowMenu(!showMenu);
                  }}
                  className={styles.menu_icon}
                >
                  <img src={closeIcon} alt='menu' />
                </div>
              )}
            </div>
          </div>
        </div>

        <SelectWorkspace />

        {showExpireAlertBox && (
          <PackageExpireAlert
            remainingDays={remainingDaysNum}
            accountType={accountType}
          />
        )}

        <div
          className={styles.content}
          style={{
            // maxHeight: `calc(100vh - ${menuHeaderHeight + 12}px)`,
            height: `calc(100vh - ${162}px)`,
          }}
        >
          {renderContent}
        </div>
      </div>
    </div>
  );
}

export default SideMenu;
